import styled from "styled-components";
import { colors } from "../../../../theme/theme";

export const ContactForm = styled.div`  
   .card-header{
       background-color: ${colors.mainColors.verde_dstore};
       color: ${colors.greyscale.white};
   }

   .card-footer{
        background-color: ${colors.greyscale.white};
   }
`;